export default {
  props: [
    'videos'
  ],
  computed: {
    fetchVideos() {
      return this.videos;
    }
  },
  methods: {
    fetchPicture(img) {
      if(typeof img.maxrex !== 'undefined') {
        return img.maxrex.url;
      }

      if(typeof img.high !== 'undefined') {
        return img.high.url;
      }

      if(typeof img.medium !== 'undefined') {
        return img.medium.url;
      }

      if(typeof img.standard !== 'undefined') {
        return img.standard.url;
      }

      if(typeof img.default !== 'undefined') {
        return img.default.url;
      }

      return img;
    }
  },
}